import React, { Component } from 'react'
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button'
import { Spinner, SpinnerColorScheme } from '@amzn/stencil-react-components/spinner'

export class LoadingButton extends Component {

  getIcon(buttonVariant, loading, icon) {
    if (loading) {
      const shouldInvertColorScheme = buttonVariant === ButtonVariant.Primary;
      return (<Spinner
                dataTestId={'loading-btn-spinner'}
                colorScheme={shouldInvertColorScheme ? SpinnerColorScheme.Inverted : SpinnerColorScheme.Default} 
              />);
    }

    return icon;
  }

	render() {
    const { variant, loading, icon } = this.props;

		return (
      <Button
        onClick={this.props.onClick}
        variant={variant}
        icon={this.getIcon(variant, loading, icon)}
        key={this.props.key}
        disabled={this.props.disabled}
        dataTestId={this.props.dataTestId ? this.props.dataTestId : 'loading-btn'}
      >
        {this.props.text}
      </Button>
    )
	}
}